import React, { Fragment } from "react";
import "./hero17.css"
const Hero17 = (props) => {
  return (
    <div className="hero17-header78">
      <div className="hero17-column thq-section-padding thq-section-max-width">
        <div className="hero17-content1">
          <h1>
            {props.heading1 ?? (
              <Fragment>
                <h1 className="hero17-text7 thq-heading-1">
                  Welcome to Our Consultancy Services
                </h1>
              </Fragment>
            )}
          </h1>
          <p>
            {props.content1 ?? (
              <Fragment>
                <p className="hero17-text6 thq-body-large">
                  We provide expert consultancy services to help your business
                  thrive.
                </p>
              </Fragment>
            )}
          </p>
        </div>
        <div className="hero17-actions">
          {/* Add buttons here if needed */}
        </div>
      </div>
      <div className="hero17-content2">
        <div className="hero17-row-container1 thq-mask-image-horizontal thq-animated-group-container-horizontal">
          <div className="thq-animated-group-horizontal">
          <img
              alt={props.image6Alt || "Image 6"}
              src="/tech 4.jpg"
              className="hero17-placeholder-image15 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image6Alt || "Image 6"}
              src="/tech 3.jpg"
              className="hero17-placeholder-image15 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image6Alt || "Image 6"}
              src="/tech 2.jpg"
              className="hero17-placeholder-image15 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image6Alt || "Image 6"}
              src="/tech1.jpg"
              className="hero17-placeholder-image15 thq-img-scale thq-img-ratio-1-1"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero17;
